import type { LocalizedText } from "../i18n/i18n";
import { cycleUnitLabelKey } from "./cycleUnitI18n";

/** Single-unit billing/cycle label (CycleUnit 1…5; same keys as contract templates). */
export function billingCycleLabel(cycle?: number | null, text?: (value: LocalizedText) => string): string {
  const c = Number(cycle ?? 0);
  const key = cycleUnitLabelKey(c);
  if (!key) return String(cycle ?? "–");
  return text ? text(key) : key;
}

export function billingCycleOptions(text: (value: LocalizedText) => string) {
  return [
    { value: 1, label: billingCycleLabel(1, text) },
    { value: 2, label: billingCycleLabel(2, text) },
    { value: 3, label: billingCycleLabel(3, text) },
    { value: 4, label: billingCycleLabel(4, text) }
  ];
}



